import type { ActivityFeedDayGroups } from './activityFeedList.types';

export const getActivityFeedItemKeys = (groups: ActivityFeedDayGroups): string[] =>
  groups.flatMap((group, groupIndex) => [
    `day-${groupIndex}-${group.dayKey}`,
    ...group.items.map((item) => item.row.id),
  ]);
